{
  "Language.SelectorLabel": "Changer de langue",
  "Language.FollowMicrosoft365": "Utiliser ma langue Microsoft 365",
  "Language.SaveFailed": "Votre choix de langue n'a pas pu être enregistré. Il s'applique dans ce navigateur jusqu'à votre prochaine visite.",
  "Header.SignOut": "Se déconnecter",
  "Workspace.Brand": "Collaboration fournisseurs Edinshall",
  "Workspace.Title": "Espace qualité fournisseurs"
}
